module.exports = __webpack_public_path__ + "static/media/tnc.1acf5226.webp";